import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { withRouter } from 'react-router'
import { Field } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import Spinner from '../../components/Widgets/spinner';
import InputField from '../Common/inputField';
import { Translate } from 'react-redux-i18n';

//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style';

class ZoneForm extends Component {
  handleZoneFormSubmit(formProps) {
    const props = {...formProps, zone_num: formProps.Name, Description: formProps.Description || '',  };
    if (this.props.currentZone) {
      this.props.editZone(props);
    } else {
      this.props.createZone(props, this.props.currentWarehouse.Warehouse_id);
    }
  }

  handleBinFormSubmit(formProps) {
    const {selectedBin} = this.props;
    const props = {section_num: formProps.Name, description: formProps.description || '', zone_id: this.props.value || selectedBin.zone_id_id  };
    if (this.props.currentBin && selectedBin) {
      this.props.editBins(props, selectedBin.id);
    } else {
      this.props.generateBin(props);
    }
  }
   
  handleLevelFormSubmit(formProps) {
    const { selectedLevel } = this.props;
    const props = {bin_num: formProps.Name, description: formProps.description || '', section_id: this.props.value || selectedLevel.section_id_id };
    if (this.props.currentLevel && selectedLevel) {
      this.props.editLevels(props, selectedLevel.id);
    } else {
      this.props.createBin(props);
    }
  }

  renderZoneForm() {
    const { detailError, detailIsLoading, handleSubmit, submitting, pristine, valid, closeG } = this.props;
    if (detailIsLoading && !detailError) return <Spinner className="marginTopStyle" />
    else if (detailError) return <div className="alert alert-danger">{JSON.stringify(this.props.detailError) }</div>
    if (this.props.hierarchy === 'zone') {
      return (
        <form method="get" action="#" onSubmit={handleSubmit(this.handleZoneFormSubmit.bind(this)) } >
          <br/>
          <div className="pull-right">
            { this.props.isCreating || this.props.isEditing && <Spinner/> }
            <button action="submit" className="btn btn-primary buttonStyle" disabled={ submitting || pristine || !valid } ><Translate value="save" /></button>
            <button className="btn btn-danger buttonStyle" onClick={(event) => { event.preventDefault(); closeG(); } } ><Translate value="cancel" /></button>
          </div>
          <Row>
            <Row>
              <Col sm={1} />
              <Col sm={4}>
                <div className="form-group">
                  <label><em className="fa fa-building-o marginRightStyle" />| <Translate value="zone_name" /> (*) </label>
                  <Field name="Name" component={ InputField } placeholder="Zone Name" />
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={1} />
              <Col sm={4}>
                <div className="form-group">
                  <label><em className="fa fa-building-o marginRightStyle" /><Translate value="Description" /> </label>
                  <Row><Col sm={12}><Field name="description" component="Textarea" className="form-control" style={{ minHeight: '150px' }}/></Col></Row>
                </div>
              </Col>
            </Row>
          </Row>
        </form>
      );
    } else {
      return <div />
    }
  }

  renderBinForm() {
    const { detailError, detailIsLoading, handleSubmit, submitting, pristine, valid, closeG } = this.props;
    if (detailIsLoading && !detailError) return <Spinner className="marginTopStyle" />
    else if (detailError) return <div className="alert alert-danger">{JSON.stringify(this.props.detailError) }</div>
    if (this.props.hierarchy === 'bin') {
      return (
        <form method="get" action="#" onSubmit={handleSubmit(this.handleBinFormSubmit.bind(this)) } >
          <br/>
          <div className="pull-right">
            { this.props.isCreating || this.props.isEditing && <Spinner/> }
            <button action="submit" className="btn btn-primary buttonStyle" disabled={ submitting || pristine || !valid } ><Translate value="save" /></button>
            <button className="btn btn-danger buttonStyle" onClick={(event) => { event.preventDefault(); closeG(); } } ><Translate value="cancel" /></button>
          </div>
          <Row>
            <Row>
              <Col sm={1} />
              <Col sm={4}>
                <div className="form-group">
                  <label><em className="fa fa-building-o marginRightStyle" />| <Translate value="bin_name" /> (*) </label>
                  <Field name="Name" component={InputField} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={ 1 } />
              <Col sm={ 4 }>
                <div className="form-group">
                  <label><em className="fa fa-building-o marginRightStyle" /><Translate value="Description" /> </label>
                  <Row><Col sm={ 12 }><Field name="description" placeholder={this.props.currentBin ? this.props.currentBin.description : "Description"}
                    component="Textarea" className="form-control" style={{ minHeight: '150px' }}/></Col></Row>
                </div>
              </Col>
            </Row>
          </Row>
        </form>
      );
    } else {
      return ( <div />)
    }
  }

  renderLevelForm() {
    const { detailError, detailIsLoading, handleSubmit, submitting, pristine, valid, closeG } = this.props;
    if (detailIsLoading && !detailError) return <Spinner className="marginTopStyle" />
    else if (detailError) return <div className="alert alert-danger">{JSON.stringify(this.props.detailError) }</div>
    if (this.props.hierarchy === 'level') {
      return (
        <form method="get" action="#" onSubmit={handleSubmit(this.handleLevelFormSubmit.bind(this)) } >
          <br/>
          <div className="pull-right">
            { this.props.isCreating || this.props.isEditing && <Spinner/> }
            <button action="submit" className="btn btn-primary buttonStyle" disabled={ submitting || pristine || !valid } ><Translate value="save" /></button>
            <button className="btn btn-danger buttonStyle" onClick={(event) => { event.preventDefault(); closeG(); } } ><Translate value="cancel" /></button>
          </div>
          <Row>
            <Row>
              <Col sm={1} />
              <Col sm={4}>
                <div className="form-group">
                  <label><em className="fa fa-building-o marginRightStyle" />| <Translate value="level" /> (*) </label>
                  <Field name="Name" ref={"bin_num"} component={ InputField } />
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={1} />
              <Col sm={4}>
                <div className="form-group">
                  <label><em className="fa fa-building-o marginRightStyle" /><Translate value="Description" /> </label>
                  <Row><Col sm={ 12 }><Field name="description" 
                    component="Textarea" className="form-control" style={{ minHeight: '150px' }}/></Col></Row>
                </div>
              </Col>
            </Row>
          </Row>
        </form>
      )
    } else {
      return <div />
    }
  }
  render() {
    return (
      <ContentWrapper>
        {this.renderZoneForm() }
        {this.renderBinForm() }
        {this.renderLevelForm() }
      </ContentWrapper>
    )
  }
}

export default withRouter(ZoneForm);



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/zoneForm.jsx